import { render } from "./DoacoesRecebidas.vue?vue&type=template&id=062805b0&scoped=true&ts=true"
import script from "./DoacoesRecebidas.vue?vue&type=script&lang=ts"
export * from "./DoacoesRecebidas.vue?vue&type=script&lang=ts"

import "./DoacoesRecebidas.vue?vue&type=style&index=0&id=062805b0&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062805b0"]])

export default __exports__